import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UrlConfigService {
  constructor() { }

  getPortalUrl(): string {
    return environment.production 
      ? 'https://portal.blazebite.com/' 
      : 'https://qa-portal.blazebite.com/';
  }

  getMainWebsiteUrl(): string {
    return 'https://www.blazebite.com/';
  }

  getTermsAndConditionsUrl(): string {
    return `${this.getMainWebsiteUrl()}terms-and-conditions/`;
  }

  getPrivacyPolicyUrl(): string {
    return `${this.getMainWebsiteUrl()}privacy-policy-2/`;
  }

  getESignConsentUrl(): string {
    return `${this.getMainWebsiteUrl()}blazebite-e-sign-consent/`;
  }
}